<template>
  <div id="navi"
    ref="navigation"
    >
    <div class="navi-func-link">
      <span @click="table.open()" role="button" class="text">すべて開く</span>
      <span @click="table.close()" role="button" class="text">すべて閉じる</span>
    </div>
    <div class="guide-pdf-download">
      <a :href="state.printPDFURL" target="_blank" class="txt-blue ga-guide-pdf-dl" role="button"><FontawesomeIcon class="icn-download" icon="arrow-to-bottom" />&nbsp;ご利用ガイドPDFダウンロード</a>
    </div>
    <div id="navi-content" ref="naviContent" :style="{ height: 'calc(100vh - 144px)'}">
      <template v-for="(list, index) in state.table">
        <div v-if="list.guide_id && list.guide_id > 0" :key="'content' + list.guide_id" class="navi-back" role="button" :class="{
          'is-selected': guide.currentContentId && list.guide_id === guide.currentContentId,
          'mb0': state.table[index + 1] && state.table[index + 1].isDetail
          }"
          ref="items">
          <router-link :to="'/pc/guide/' + list.guide_id" class="main txt-blue" v-html="list.name"></router-link>
        </div>
        <template v-else-if="list.category_id && list.category_id > 0">
          <div @click="table.changeOpen(list.category_id)" :key="'category_top' + list.category_id" class="navi-title" v-html="list.name"></div>
          <div v-if="list.hasChild" :key="'category' + list.category_id"  class="list02">
            <PCGuideTableList :lists="list.children" :depth="list.depth" />
          </div>
        </template>
      </template>
    </div>
  </div>
</template>
<script>
import { defineComponent, reactive, computed, onBeforeMount, watch } from '@vue/composition-api'
import * as apiGuide from '@/api/guide'
import * as apiCommon from '@/api/common'
import * as _ from 'lodash'
import PCGuideTableList from '@/components/pc/partial/guide/PCGuideTableList.vue'

export default defineComponent({
  name: 'PCGuideTable',
  components: {
    PCGuideTableList
  },
  setup (props, context) {
    const store = context.root.$store
    const { guide } = store.state

    onBeforeMount(async () => {
      const cache = store.getters['guide/table']
      cache.length === 0 && table.loadTable()

      // // ご利用ガイドPDFのURLを取得
      // // ファイルタイプ：管理者の場合は「10=ご利用ガイドPDF(管理メニューも含む)」、管理者でない場合は「9=ご利用ガイドPDF(目次のみ)」
      // const fileType = state.isAdmin ? 10 : 9
      // const params = {
      //   file_type: fileType
      // }
      // await apiGuide.getPrintPDF(params)
      //   .then(res => {
      //     const { data } = res
      //     const fileId = data.file_id
      //     state.printPDFURL = apiCommon.getFetchFileAPIURL(fileId, true)
      //   })
    })

    const table = {
      loadTable: async() => {
        await apiGuide.table().then(res => {
          const { data } = res
          if (data.list) {
            const topPage = _.find(data.list, 'guide_id')

            if (topPage) {
              const { guide_id: guideId } = topPage
              store.dispatch('guide/setTopPageId', guideId)
            }

            const lists = table.recursiveMap(data.list)
            store.dispatch('guide/setTable', lists)
          }
        })
      },
      // ツリーに必要な情報を作成しておく
      recursiveMap: (lists, depth = 0) => {
        const listsMaped = _.map(lists, list => {
          list.isOpen = false
          list.isCategory = !list.guide_id
          list.isDetail = !!list.guide_id
          list.hasChild = (list.children && list.children.length > 0)
          list.depth = depth

          if (list.hasChild) {
            list.children = table.recursiveMap(list.children, depth + 1)
          }

          return list
        })

        return listsMaped
      },
      open: () => {
        store.dispatch('guide/allOpen')
      },
      close: () => {
        store.dispatch('guide/allClose')
      }
    }

    const state = reactive({
      table: computed(() => store.getters['guide/table']),
      // 印刷用PDFのURL
      printPDFURL: computed(() => {
        if (state.isAdmin) {
          return '/lc/app-pdf/guide_pdf.php?type=toc&download=1'
        } else {
          return '/lc/app-pdf/guide_pdf.php?type=am&download=1'
        }
      }),
      isAdmin: computed(() => store.getters['profile/isAdmin'])
    })

    watch(() => guide.scrollTo, (now, old) => {
      if (now !== null) {
        context.root.$nextTick(() => {
          context.refs.naviContent.scrollTop = now
        })
      }
    })

    watch(() => guide.currentContentId, (now, old) => {
      if (now) {
        const index = _.findIndex(state.table, list => list.guide_id === now)
        if (index !== -1) {
          context.root.$nextTick(() => {
            // スクロール位置を調整する
            const top = context.refs.items[index].offsetTop
            store.dispatch('guide/scrollTo', top - 100)
          })
        }
      }
    })

    return {
      state,
      table,
      guide
    }
  }
})
</script>

<style lang="scss" scoped>
.navi-func-link {
  font-size: 1.2rem;
  color: $color-sup;
  margin: 10px 24px 10px 24px;
  .text {
    text-decoration: underline;
  }
  .text + .text {
    padding-left: 20px;
    margin-left: 20px;
    border-left: 1px solid $color-line;
  }
}

.guide-pdf-download {
  font-size: 1.4rem;
  margin: 10px 10px 10px 24px;

}

.navi-title {
  padding: 0 20px;
  margin-top: 10px;
  margin-bottom: 8px;
  color: $color-hdg;
  font-size: 2.0rem;
  font-weight: bold;
}
.navi-back {
  padding: 0 20px;
  margin-top: 0px;
  margin-bottom: 15px;
  font-size: 1.6rem;
  padding-top: 0.3em;
  padding-bottom: 0.3em;
}
.is-selected {
  background-color: $color-selected;
}
#navi {
  position: relative;
  padding: 0;
  background-color: transparent;
  border-radius: 8px 0 0 8px;
  width: 25%;
  margin-top: 0;
  left: 0;
  border-right: 1px solid $color-line;
  transition: width .2s ease;
  &.is-fullsize {
    width: 100%;
    border-right: 0;
  }
}
#navi-content .list02 .list02-item {
  .wrap.wrap-top {
    padding: 10px 24px;
  }
}
#navi-content {
  overflow: auto;
  line-height: 1.2em;
  .list02 {
    margin-top: 0;
    overflow: auto;
    &-list {
      padding-bottom: 40px;
    }
    &-item {
      .wrap {
        padding-right: 24px;
        padding-left: 24px;
      }
      .button {
        right: 0;
        width: 48px;
        font-size: 1.4rem;
      }
      &.is-selected {
        background-color: $color-selected;
      }
      &:not(.is-parent) .wrap .label:before {
        content: "";
        display: block;
        width: 4px;
        height: 4px;
        background-color: #555555;
        border-radius: 2px;
        position: absolute;
        top: 10px;
        left: 4px;
      }
    }
    .wrap .label .icn-before {
      top: 2px;
    }
  }
}

</style>
